<template>
    <section>
        <div class="page-wrap">
            <div class="container checkout">
                <div class="box-content">
                    <share-story hr="below" v-bind:order="orderId"></share-story>
                    <div class="row">
                        <div class="col-md-12">
                            <h4 class="mt-10">
                                <strong>
                                    Thank you for supporting the Titan Promenade Tribute Program!
                                </strong>
                            </h4>
                            <h2>Order Summary</h2>
                            <div>
                                <div class="th hidden-xs">
                                    <div class="row">
                                        <div class="col-sm-3">PRODUCT</div>
                                        <div class="col-xs-9">
                                            <div class="row">
                                                <div class="col-xs-1 text-center">QTY</div>
                                                <div class="col-xs-4 col-md-4">DESCRIPTION</div>
                                                <div class="col-xs-7 col-md-7">SHIPPING ADDRESS (if applicable)</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tb" v-for="(item, itemIndex) in cart">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <div class="prod-container">
                                                <img v-if="item.gc" class="prod-img" src="images/giftcertificate.png"/>
                                                <template v-else>
                                                    <img class="prod-img" v-bind:src="getCartItemImage(item)"/>
                                                    <div class="prod-replica cart-img">
                                                        <div class="prod-replica-table">
                                                            <div class="prod-replica-table-td confirmation" v-bind:class="products[item.item_id].classes">
                                                                <p v-for="n in products[item.item_id].max_lines">{{ item.lines[n-1] }}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="col-sm-9">
                                            <template v-if="item.gc">
                                                <!-- GIFT CERTIFICATE has one shipping address for all items -->
                                                <template v-if="itemIndex in shipItemTo && 'qtys' in shipItemTo[itemIndex]">
                                                    <div class="row tr" v-for="(qty, qtyIndex) in shipItemTo[itemIndex].qtys">
                                                        <div class="col-xs-1 text-center">
                                                            <div class="wrap-count">
                                                                <div class="amount">
                                                                    <span>1</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-html="products[item.item_id].description + ' GIFT CERTIFICATE'" class="col-xs-4 col-md-4"></div>
                                                        <div class="col-xs-7 col-md-7">
                                                            {{ addresses[qty.address_id] | addressToString }}
                                                        </div>
                                                    </div>
                                                    <div class="row tr" v-for="(qty, childId) in cart[itemIndex].children">
                                                        <template v-if="qty > 0">
                                                            <div class="col-xs-1 text-center">
                                                                <div class="wrap-count">
                                                                    <div class="amount">
                                                                        <span>{{ qty }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-html="baseProductChildren[childId].description" class="col-xs-4 col-md-4"></div>
                                                            <div class="col-xs-7 col-md-7"></div>
                                                        </template>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!-- a PAVER set can have no shippping address(es) at all -->
                                                <div class="row tr">
                                                    <div class="col-xs-1 text-center">
                                                        <div class="wrap-count">
                                                            <div class="amount">
                                                                <span>1</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-html="products[item.item_id].description" class="col-xs-4 col-md-4"></div>
                                                    <div class="col-xs-7 col-md-7">
                                                        <!-- not shippable -->
                                                    </div>
                                                </div>
                                                <template v-if="itemIndex in shipItemTo && 'qtys' in shipItemTo[itemIndex]">
                                                    <div class="row tr" v-for="(qty, qtyIndex) in shipItemTo[itemIndex].qtys">
                                                        <div class="col-xs-1 text-center">
                                                            <div class="wrap-count">
                                                                <div class="amount">
                                                                    <span>1</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-html="baseProductChildren[qty.item_id].description" class="col-xs-4 col-md-4"></div>
                                                        <div class="col-xs-7 col-md-7">
                                                            {{ addresses[qty.address_id] | addressToString }}
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <div class="total">Subtotal:
										<span class="wrap">
											<span class="pull-left">$&nbsp;</span>{{ subTotal | currency({symbol: ''}) }}
										</span>
                                    </div>
									<div class="total" v-if="isPromoCodeAllowed">Promotional Discount
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ promoDiscount.toFixed(2) }}
                                        </span>
                                    </div>
                                    <div class="total">Sales&nbsp;Tax:
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ salesTax | currency({symbol: ''}) }}
                                        </span>
                                    </div>
                                    <div class="total" v-if="isConvenienceFeeAllowed">Web Convenience&nbsp;Fee:
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ convenienceFee | currency({symbol: ''}) }}
                                        </span>
                                    </div>
                                    <strong class="subtotal">Order&nbsp;Total:
                                        <span>$&nbsp;</span>{{ orderTotal | currency({symbol: ''}) }}
                                    </strong>
                                </div>
                                <hr>
                                <h2>Order Confirmation</h2>
                                <div>
                                    <p>
                                        Your order is being processed. A confirmation email detailing your order and next steps will be sent to you shortly. If you have checked your junk folder and still have not received an email within 24 hours of placing your order, please call 1-888-223-0291 to speak with a customer service specialist.
                                    </p>
                                    <a class="btn btn-outline-danger btn-lg" v-on:click="onPrintReceipt">Print Receipt</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    import store from '../store'
    import { mapState, mapGetters } from 'vuex'
    // mixins
    import CampaignConfigurationMixin from '../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    import OrderCreationMixin from '@/components/mixin/order-creation.vue'

    import ShareStory from '@/components/ShareStory.vue';
    export default {
        name: 'confirmation',
        mixins: [
            CampaignConfigurationMixin,
            OrderCreationMixin,
            require('../../../../assets/js/components/frontend/mixin/filters.vue')
        ],
        components: {
            'share-story': ShareStory
        },
        beforeRouteEnter (to, from, next) {
            if (from.name === 'Payment' && store.getters.isOrderCompleted) {
                next();
            } else {
                next({ name: 'Checkout' });
            }
        },
        beforeRouteLeave (to, from, next) {
            store.commit('clearCompletedOrder');
            next();
        },
        computed: {
            ...mapState([
                'campaign', 'orderId'
            ]),
            ...mapGetters([
                'products', 'childProducts', 'cart',
                'hasShippableItems', 'subTotal', 'promoDiscount', 'salesTax',
                'shipItemTo', 'addresses'
            ]),
            ...mapGetters({
                baseProductChildren: 'baseProductShippableChildren'
            }),
            baseImagePath: function () {
                return 'images/catalog/' + this.campaign.short_url + '/';
            }
        },
        methods: {
            getCartItemImage: function (cartItem) {
                var itemId = cartItem.item_id;
                var product = this.products[itemId];
                var logosList = {};
                if (this.isMultiLogoAllowed) {
                    if ("options" in product && product.options) {
                        if ("logo" in product.options && product.options.logo) {
                            logosList = product.options.logo;
                        }
                    }
                }
                var res = '';
                var logoId = 'logo' in cartItem.options ? cartItem.options.logo : '';
                if (logoId in logosList) {
                    res = this.baseImagePath + logosList[logoId].item_image_blank;
                    return res;
                }
                res = this.baseImagePath + product.item_image_blank;
                return res;
            },
            onPrintReceipt: function () {
                window.print()
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Confirmation.vue?30985156